
<div class="card">
    <div class="card-body " >
            <div class="container">
                <div class="row">
            <div class="col">

                <h5> <a (click)="goto('/administration')">Etat des stationnements</a></h5>
                <ul>
                  <li>Etat des installations</li>
                  <li>Programmer les horaires de fonctionnement</li>
                  <li> Historique des passages</li>
                </ul>
              <h5> <a (click)="goto('/configurations')"> Configurations</a></h5>
                <ul>
                  <li>PMR </li>
                  <li>Payant </li>
                  <li>Gratuit</li>
                  <li>Résident </li>
                  <li>Privé </li>
                  <li>Secours </li>
                  <li>Livraison </li>
                </ul>
                <h5> <a (click)="goto('/configurations')"> Automatismes</a></h5>
              <ul>
                <li>Afficher les programmes</li>
                <li>Créer un programme</li>
                <li>Modifier un programme</li>
              </ul>
            </div>
            <div class="col">
              <div>
                <h5> <a (click)="goto('/stats')">Gestion des utilisateurs </a></h5>
                <div>
                  <ul>
                    <li>Rechercher un utilisateur </li>
                    <li>Modifier un profil utilisateur</li>
                  </ul>
                </div>
              </div>
              
              <div>
                <h5> <a (click)="goto('/stats')">  Gestion des badges</a></h5>
                <div>
                  <ul>
                    <li>Créer un badge </li>
                    <li>Révoquer un badge </li>
                    <li>Configurer un badge</li>
                    <ul>
                    <li>Badges agent</li>
                    <li>Badges résident</li>
                    <li>Badges préchargé</li>
                    <li>Badges abonné</li>
                    </ul>
                    
                  </ul>
                </div>
              </div>             

              <div>
                <h5  class="desactive">  Incivilités</h5>
                <div>
                  <ul>
                    <li>Analyse des dépassements </li>
                    <li>Avertissement </li>
                    <li>Révoquer un accés </li>
                  </ul>
                </div>
              </div>

              <div>
                <h5> <a (click)="goto('/stats')"> Statistiques</a></h5>
                <div>
                  <ul>
                    <li>Voir les chiffres instantanés </li>
                    <li>Rechercher</li>
                    <li>Exporter</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
